export default __webpack_public_path__ + "static/media/Back.d9a13d61.png";